<template>
  <div class="topBar sy">
    <div class=" top-nav-wrapper" >
<!--    <div class=" top-nav-wrapper" :class="{'haveBorder':$route.path!='/'|| $route.path =='account'}">-->
      <div class="d-flex justify-content-between">
        <!--    左侧logo-->
        <div class="left-nav col-3" @click="$router.push('/')">
          <img  id="log-img" src="../../assets/img/logo.png"/>
          <div class="cx-code d-md-block d-none ">
            <span>股票代码605567</span>
          </div>
        </div>
        <!--      中间item-->
        <div class="middle-nav col-7 d-md-block d-none container-fluid">
            <div class="row justify-content-start">
              <div class="col select-item">
                <span>企业介绍</span><ul class="ul-li">
                  <li @click="$router.push('/service')">服务宗旨</li>
                  <li @click="$router.push('/develop')">企业发展历程</li>
                  <li @click="$router.push('/partner')">合作伙伴</li>
                  <li @click="$router.push('/boss')">董事长致辞</li>
<!--                  <li @click="$router.push('/organization')">组织架构图</li>-->
                </ul>
              </div>
              <div class="col select-item" >
                <span @click="$router.push('/goodinfo')">商品信息</span>
                <ul class="ul-li">
                  <li class="goodInfo" @click.prevent="$router.push('/goodinfo')">商品信息
                    <ul class="ul-li2">
                      <li @click.stop="$router.push('/fried')">油炸电烤类</li>
                      <li @click.stop="$router.push('/coated')">上粉类</li>
                      <li @click.stop="$router.push('/chinese')">中华菜类</li>
                      <li @click.stop="$router.push('/charcoal')">炭烤类</li>
                      <li @click.stop="$router.push('/steam')">蒸煮类</li>
                      <li @click.stop="$router.push('/rawmarinade')">生调理品</li>
                      <li @click.stop="$router.push('/raw')">生品类</li>
<!--                  <li @click.stop="$router.push('/vegetable')">植物基</li>-->
                    </ul>
                  </li>
                  <li @click="$router.push('/saleinfo')">产品应用</li>
                </ul>

              </div>
              <div class="col select-item" @click="$router.push('/newslist')"><span>新闻播报</span></div>
              <div class="col select-item"><span @click="$router.push('/recruit')">招聘信息</span>
                <ul class="ul-li">
                  <li @click="$router.push('/account')">财务管理</li>
                  <li @click="$router.push('/sale')">营销管理</li>
                  <li @click="$router.push('/food')">食品研发</li>
                  <li @click="$router.push('/product')">生产管理</li>
                  <li @click="$router.push('/tec')">技术管理</li>
                  <li @click="$router.push('/synthesis')">综合</li>
                </ul>
              </div>
              <div class="col select-item" @click="touZi"><span>投资关系</span></div>
            </div>
        </div>
        <!--      右侧icon-->
        <div class="right-nav col-2 align-self-center">
            <img src="../../assets/img/jd.png" alt="京东" class="d-md-inline d-none" @click="jingdong">
            <img src="../../assets/img/tm.png" alt="天猫" class="d-md-inline d-none" @click="tianmao">
            <div class="d-md-none d-block rightIcon" @click="changeIcon">
              <svg :class="[showOrder==0?'show':'off']" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-justify-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
              </svg>

              <svg :class="[showOrder!=0?'show':'off']" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chevron-bar-contract" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M3.646 14.854a.5.5 0 0 0 .708 0L8 11.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-13.708a.5.5 0 0 1 .708 0L8 4.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"/>
              </svg>
            </div>
        </div>
      </div>
    </div>
    <ul class="phoneList col-12 d-block d-md-none" ref="ulList">
      <svg style="position: absolute;color: #F6F4F5;top:8px" :class="[showOrder>1?'show':'off']" @click="backList" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
      </svg>
      <li :class="[showOrder==1?'show':'off']" @click="producesList">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-file-person" viewBox="0 0 16 16">
          <path d="M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/>
          <path d="M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
        </svg>
        企业介绍
      </li>
      <li :class="[showOrder==1?'show':'off']" @click="goodsList">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
          <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/>
        </svg>
        商品信息
      </li>
      <li :class="[showOrder==1?'show':'off']" @click="routerChange('/newsList')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-newspaper" viewBox="0 0 16 16">
          <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5v-11zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5H12z"/>
          <path d="M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"/>
        </svg>
        新闻播报
      </li>
      <li :class="[showOrder==1?'show':'off']" @click="recruitsList">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-people" viewBox="0 0 16 16">
          <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
        </svg>
        招聘信息
      </li>
      <li :class="[showOrder==1?'show':'off']" @click="touZi">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-display" viewBox="0 0 16 16">
          <path d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z"/>
        </svg>
        投资播报
      </li>

      <li :class="[showOrder==2?'show':'off']" @click="routerChange('/service')">服务宗旨</li>
      <li :class="[showOrder==2?'show':'off']" @click="routerChange('/develop')">企业发展历程</li>
      <li :class="[showOrder==2?'show':'off']" @click="routerChange('/partner')">合作伙伴</li>
      <li :class="[showOrder==2?'show':'off']" @click="routerChange('/boss')">董事长致辞</li>
      <li :class="[showOrder==2?'show':'off']" @click="routerChange('/organization')">组织架构图</li>
      <li :class="[showOrder==3?'show':'off']" @click="routerChange('/goodinfo')">商品信息</li>
      <li :class="[showOrder==3?'show':'off']" @click="routerChange('/saleinfo')">产品应用</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/account')">财务管理</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/sale')">营销管理</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/food')">食品研发</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/product')">生产管理</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/tec')">技术管理</li>
      <li :class="[showOrder==4?'show':'off']" @click="routerChange('/synthesis')">综合管理</li>
    </ul>
  </div>

</template>
<script>
export default {
  name: "TopNav",
  data(){
    return{
      showOrder:0,
    }
  },
  methods:{
    touZi(){
      window.open('https://open.sseinfo.com/ir2/indexkcb?language=zh_CN&stockCode=605567')
    },
    jingdong(){
      window.open('https://mall.jd.com/index-11821908.html')
    },
    tianmao(){
      window.open('https://chunxueshipin.tmall.com/search.htm?spm=a220m.1000858.1000725.3.3f56703fRO29i6')
    },
    changeIcon(){
      if(this.showOrder===0){
        this.$refs.ulList.style.height='170px';
        // this.$refs.ulList.style.backgroundColor='#4D3C5C'
        this.$refs.ulList.style.backgroundColor='#000'
        this.showOrder=1;
      }else {
        this.$refs.ulList.style.height='0px';
        this.$refs.ulList.style.backgroundColor='#fff'
        this.showOrder=0;
      }
    },
    routerChange(path){
      this.changeIcon();
      this.$router.push(path)
    },
    backList(){
      this.showOrder=1;
      this.$refs.ulList.style.height='170px';
    },
    producesList(){
      this.showOrder=2;
    },
    goodsList(){
      this.showOrder=3
    },
    recruitsList(){
      this.$refs.ulList.style.height='200px';
      this.showOrder=4
    }
  },
}
</script>

<style lang="less" scoped>
.show{
  display: block !important;
}
.off{
  display: none !important;
}
.haveBorder{
  border-bottom: 1px gainsboro dashed;
}
.topBar{
  position: relative;
  top:0;
  z-index: 999;
  font-weight: 500;
}
.top-nav-wrapper{
  margin: 0 auto;
  max-width: 1920px;
  background-color: #ffffff;
  text-align: center;
  font-family: "sy";
  z-index: 999;
  position: relative;
  .left-nav{
    padding-left: 1rem;
    #log-img{
      width: 160px;
      height: auto;
      margin-top: 1.5rem;
      padding: 0;
    }
    .cx-code{
      width: 100%;
      text-align: center;
      letter-spacing:.2rem;
      font-size: 100%;
      font-weight: bold;
    }
  }
  .middle-nav{
    font-size: 150%;
    line-height: 6rem;
    .row {
      height: 100%;
      div {
        padding: 0;
        position: relative;
        ul {
          position: absolute;
          width: 100%;
          top: 6rem;
        }
        span {
          display: block;
          width: 100%;
          transition: all .3s;
          height: 100%;
        }

        &:hover span {
          //background-color: #4D3C5C;
          background-color: #000;
          color: #ffffff;
        }

        &:hover .ul-li > li {
          height: 3rem;
          //background-color: #4D3C5C;
          background-color: #000;

          color: #ffffff;
          transition: all .3s;
          line-height: 3rem;
        }

        .ul-li > li {
          font-size: 90%;
          line-height: 3rem;
          height: 0;
          overflow: hidden;
          transition: all .2s;
          &:hover {
            background-color: #ffeecc;
            color: #333333;
          }
        }

        .goodInfo .ul-li2 {
          color: #333;
          position: absolute;
          top: 0px;
          line-height: 0px;
          height: 0;
          overflow: hidden;
          right: -100%;
          width: 100%;
          li {
            height: 3rem;
          }
        }

        .goodInfo:hover .ul-li2 {
          line-height: 3rem;
          height: 21rem;
          //background-color: #4D3C5C;
          background-color: #000;
          text-align: center;
          color: #ffffff;
          transition: all .3s;
          li:hover {
            background-color: #ffeecc;
            color: #333;
          }
        }

      }
    }
  }
  .right-nav{
    padding: 0;
    img{
      width: 50px;
      height: auto;
    }
    div{
      margin-right: 1rem;
    }
  }
}
@media (max-width: 767px) {
  .top-nav-wrapper .left-nav #log-img{
    margin: 1rem auto 1rem 1rem  ;
  }
}
.rightIcon{
  position: relative;
}
.phoneList{
  background-color: #fff;
  position: absolute;
  padding-bottom: .3rem;
  transition: all .5s;
  overflow: hidden;
  height: 0;

  li{
    position: relative;
    margin: 0 auto;
    text-align: center;
    display: block;
    width: 80%;
    line-height: 2rem;
    color: #fff;
    border-bottom: 1px rgba(255,255,255,.1) dashed;
    vertical-align: center;
    svg{
      vertical-align: baseline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav/index.vue